module.exports = __webpack_public_path__ + "img/Kelvin Lawrence.7eae736a.jpg";